/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForClientSkuReqVo
 */
export interface OrderInfoForClientSkuReqVo {
    /**
     * 当前页，默认1
     * @type {number}
     * @memberof OrderInfoForClientSkuReqVo
     */
    currentPage?: number;
    /**
     * 每页条数，默认30，最大1000
     * @type {number}
     * @memberof OrderInfoForClientSkuReqVo
     */
    pageSize?: number;
    /**
     * 订单ID列表
     * @type {Array<number>}
     * @memberof OrderInfoForClientSkuReqVo
     */
    orderIds?: Array<number>;
    /**
     * 请求类型 1-处理中 2-已出库 3-出库取消 4-原运单退货 如果要查询全部就传null
     * @type {number}
     * @memberof OrderInfoForClientSkuReqVo
     */
    skuOrderType?: number;
    /**
     * SKU ID
     * @type {number}
     * @memberof OrderInfoForClientSkuReqVo
     */
    skuId?: number;
    /**
     * 排序字段：quantity-当前SKU组合商品记录数、receiveAddress-收货地址、createTime-订单创建时间；不传或非法值默认createTime
     * @type {string}
     * @memberof OrderInfoForClientSkuReqVo
     */
    sortField?: string;
    /**
     * 排序方向：asc/desc，创建时间默认desc，数量及收货地址默认asc
     * @type {string}
     * @memberof OrderInfoForClientSkuReqVo
     */
    sortOrder?: string;
}

/**
 * Check if a given object implements the OrderInfoForClientSkuReqVo interface.
 */
export function instanceOfOrderInfoForClientSkuReqVo(value: object): value is OrderInfoForClientSkuReqVo {
    return true;
}

export function OrderInfoForClientSkuReqVoFromJSON(json: any): OrderInfoForClientSkuReqVo {
    return OrderInfoForClientSkuReqVoFromJSONTyped(json, false);
}

export function OrderInfoForClientSkuReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForClientSkuReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
        'skuOrderType': json['skuOrderType'] == null ? undefined : json['skuOrderType'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'sortField': json['sortField'] == null ? undefined : json['sortField'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function OrderInfoForClientSkuReqVoToJSON(json: any): OrderInfoForClientSkuReqVo {
    return OrderInfoForClientSkuReqVoToJSONTyped(json, false);
}

export function OrderInfoForClientSkuReqVoToJSONTyped(value?: OrderInfoForClientSkuReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'orderIds': value['orderIds'],
        'skuOrderType': value['skuOrderType'],
        'skuId': value['skuId'],
        'sortField': value['sortField'],
        'sortOrder': value['sortOrder'],
    };
}

